import * as React from 'react';

import { ChatMessageMenuContext, ChatMessageMenuProps } from './context';

export const useChatMessageMenu = (): ChatMessageMenuProps => {
  const context = React.useContext(ChatMessageMenuContext);
  if (!context) {
    throw new Error('useContextMenu must be used within a ContextMenuProvider');
  }

  return context;
};
